import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import {
    selectInitialPaymentOption,
    selectIsFullPricePayment,
    selectLeasingPlanPrice,
    selectProductTotalPriceByPaymentMethod,
} from '@telialt/utils/src/eshopSelectors';
import { withParams } from '@telialt/utils/src/helpers';

import { DiscountBadge } from './DiscountBadge';
import { DiscountWrapper, SummaryRow, SummaryTable } from './PredefinedLeasingSelector.styles';

export const PaymentSummary: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const isFullPricePayment = selectIsFullPricePayment(cart);
    const leasingPaymentPrice = selectLeasingPlanPrice(cart);
    const initialPaymentOption = selectInitialPaymentOption(cart);
    const totalPrice = selectProductTotalPriceByPaymentMethod(cart);

    if (isFullPricePayment) {
        return (
            <SummaryTable>
                <SummaryRow>
                    {t['eshop.product_page.leasing_selector.summary.total_price']}
                    <DiscountBadge />
                    <b>{totalPrice?.formattedValue}</b>
                </SummaryRow>
            </SummaryTable>
        );
    }

    return (
        <SummaryTable>
            <SummaryRow>
                {withParams(t['eshop.product_page.leasing_selector.summary.initial_payment'], {
                    percent: initialPaymentOption?.title,
                })}
                <b>{initialPaymentOption?.initialPaymentPrice?.formattedValue}</b>
            </SummaryRow>
            <SummaryRow>
                {t['eshop.product_page.leasing_selector.summary.monthly_price']}
                <b>{leasingPaymentPrice?.formattedValue}</b>
            </SummaryRow>
            <SummaryRow>
                {t['eshop.product_page.leasing_selector.summary.total_price']}
                <DiscountWrapper>
                    <b>{totalPrice?.formattedValue}</b>
                    <DiscountBadge />
                </DiscountWrapper>
            </SummaryRow>
        </SummaryTable>
    );
};
